import script from "./math.vue?vue&type=script&setup=true&lang=ts"
export * from "./math.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__